import { separator } from "./separator";
import type { DropdownButton, DropdownLink, DropdownOption } from "./types";

interface ModeratorOptionsProps {
  content: DropdownLink[];
  moderation: DropdownLink;
  shortcutsModalButton: DropdownButton | null;
  showToggleTheme: boolean;
  toggleTheme: DropdownButton[];
}
export const moderatorOptions = ({
  moderation,
  showToggleTheme,
  toggleTheme,
  content,
  shortcutsModalButton,
}: ModeratorOptionsProps): DropdownOption[] => [
  ...content,
  moderation,
  ...(showToggleTheme ? [separator] : []),
  ...toggleTheme,
  ...(shortcutsModalButton ? [shortcutsModalButton] : []),
];
